export default {
    parts: ['container', 'tabBar', 'tabList', 'tab', 'content'],
    baseStyle: {
        container: {
            width: '100%'
        },
        tabBar: {
            overflowX: 'auto',
            width: '100%',
            '&::-webkit-scrollbar': {display: 'none'},
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
        },
        tabList: {
            display: 'flex',
            justifyContent: 'center',
            gap: '16px',
            width: 'fit-content',
            minWidth: '100%'
        },
        tab: {
            flexShrink: 0,
            minWidth: {base: '164px', md: '312px'},
            textStyle: 'labelXs',
            textAlign: 'center',
            p: '8px',
            border: 'none',
            backgroundColor: 'transparent',
            cursor: 'pointer'
        },
        content: {
            pt: '24px'
        }
    }
}
